import { createSlice } from '@reduxjs/toolkit';
import { getAllRoles, getRoleById } from './actions';

const initialState = {
  data: [],
  selected: {},
  isLoading: false,
  isError: false,
  errorMessage: {},
};

export const rolesSlice = createSlice({
  initialState,
  name: 'roles',
  reducers: {
    selectRole: (state, action) => {
      state.selected = action.payload;
    },
    resetSelectedRole: (state) => {
      state.selected = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllRoles.pending, (state) => {
        state.data = [];
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
      })
      .addCase(getAllRoles.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getAllRoles.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
      })
      .addCase(getRoleById.pending, (state) => {
        state.selected = {};
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
      })
      .addCase(getRoleById.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getRoleById.fulfilled, (state, action) => {
        state.selected = action.payload;
        state.isLoading = false;
      });
  },
});

export const { selectRole, resetSelectedRole } = rolesSlice.actions;
export default rolesSlice.reducer;
